import React, { ComponentType, MouseEvent, ReactElement, useCallback } from 'react';

export type PreventDefaultMouseDownProps = {
  onMouseDown?: (event: MouseEvent<HTMLElement>) => void;
};

const withPreventDefaultMouseDown = <T extends Record<string, unknown>>(
  ComponentToWrap: ComponentType<T>,
) => (props: T): ReactElement<T & PreventDefaultMouseDownProps> => {
    // Если быстро два раза нажать на Toggle, Checkbox или Radio, тогда пропадет фокус
    // Эта функция исправляет эту проблему
    const onMouseDown = useCallback((event: MouseEvent) => {
      event.preventDefault();
    }, []);

    return (
      <ComponentToWrap onMouseDown={onMouseDown}
                       {...props} />
    );
  };

export default withPreventDefaultMouseDown;
